import BossModel from "@/models/BossModel";
import Agent from '@/models/Agent/Agent';
import Dossier from "@/models/Dossier/Dossier";
import User from "@/models/User/User";
import Attachment from "@/models/Agent/Message/Attachment/Attachment";

export default class Message extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'agent/message';

    /**
     *
     * @type {string}
     */
    static entity = 'agentMessages';

    static fields() {
        return {
            id: this.number(null).nullable(),
            message: this.attr(null).nullable(),
            user_id: this.number(null).nullable(),
            dossier_id: this.number(null).nullable(),
            agent_id: this.number(null).nullable(),
            validated_by_user_id: this.number(null).nullable(),
            validated_at: this.attr(null).nullable(),
            created_at: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            agent: this.belongsTo(Agent, 'agent_id'),
            dossier: this.belongsTo(Dossier, 'dossier_id'),
            attachments: this.hasMany(Attachment, 'agent_message_id')
        }
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId) {
        return this.api()
            .where('dossier_id', dossierId)
            .with(['agent', 'user'])
            .limit(0)
            .get(true);
    }

    static unvalidatedMessagesCount() {
        return this.api().action('unvalidated').getValue();
    }
}
